import { render, staticRenderFns } from "./MailListingSentPage.vue?vue&type=template&id=782d2825&scoped=true&"
import script from "./MailListingSentPage.vue?vue&type=script&lang=js&"
export * from "./MailListingSentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782d2825",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
